import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux-store/store-config';
import { ServiceProvider } from 'types/tickets.type';

const getServiceProviders = (state: RootState): ServiceProvider[] => state.serviceProvidersState.serviceProviders;

export const selectServiceProviders = createSelector([getServiceProviders], (providers) => providers);
